import React, { useEffect } from "react";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useLocation } from "react-router-dom";
const ForClinics = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      }); // Scroll to the top when the component mounts
    }, []);
  return (
    <div className="pt-16 sm:pt-20 md:pt-24 lg:pt-[12.0625rem] text-white flex justify-center items-center flex-col  ">
      <div className="px-4 pb-8 pt-16 sm:px-6 sm:pt-10 md:px-8 md:pt-12 lg:px-10 flex 2xl:w-3/4 xl:w-4/5 w-11/12  slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16">
        <div className="text-center my-8 xl:mt-16 ">
          <h1 data-aos="fade-up"  className="text-white font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] lowercase tracking-[-.04em] leading-tight">
            For Clinicians
          </h1>

          <div data-aos="fade-up" data-aso-delay="100" className="md:text-3xl text-2xl md:leading-10 tracking-tight text-white pt-6 sm:pt-8 md:pt-10 lg:pt-12 xl:pt-[4.75rem] font-Matter">
            <p>
              Welcome to the{" "}
              <span className="text-[#cfa751]">Citrus Diagnostic Center,</span>{" "}
              where our clinicians &nbsp;play an important role through their
              dedication towards making , with continuous investment in{" "}
              <span className="text-[#cfa751]"> our patients</span>
              <span className="text-[#cfa751]"> experience easy</span> ,
              <span className="text-[#cfa751]"> comfortable</span> and
              <span className="text-[#cfa751]"> effective</span>.
              <br />
              <br />
            </p>
          </div>
        </div>
        <div className="w-full  font-Antique">
          <ul className="w-full">
            <li data-aos="fade-up" data-aso-delay="200" className="grid lg:grid-cols-2 grid-cols-1 py-10 border-b-[1px] border-[#fafaf6] border-opacity-40">
              <div className="">
                <p className="text-[#cfa751] sm:text-4xl text-2xl lg:mb-0 mb-4 font-light">
                  Refer a Patient
                </p>
              </div>
              <div>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                  For seamless appointments and booking a test for the referral
                  patients is seamless and hassle-free. All you need to do is
                  fill out the referral form below with the patient’s details
                  and get the timely updates from our clinicians.
                </p>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6]">
                  Give us a call at{" "}
                  <a className="font-bold text-[#cfa751]" href="tel:3527959200">
                    352-795-9200{" "}
                  </a>{" "}
                  from Monday to Friday, anywhere between{" "}
                  <span className="text-[#cfa751] font-bold">8:30 am</span> to{" "}
                  <span className="text-[#cfa751] font-bold"> 5 pm</span> .
                </p>
              </div>
            </li>
            <li data-aos="fade-up" data-aso-delay="300" className="grid lg:grid-cols-2 grid-cols-1 py-10 border-b-[1px] border-[#fafaf6] border-opacity-40" id="form">
              <div className="">
                <p className="text-[#cfa751] sm:text-4xl text-2xl lg:mb-0 mb-4 font-light">
                  Physician Order Form
                </p>
              </div>
              <div>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                  Our physicians can get their patients’ diagnostic results
                  online at their convenience.
                </p>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                  It also helps the patients to choose the particular test
                  according to their choice.
                </p>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6]">
                  We ensure that every test result are accurate and precise.
                </p>
                <div className="flex sm:flex-row flex-col-reverse lg:flex-col-reverse xl:flex-row gap-3  md:items-center lg:items-start xl:items-center pt-2">
                  <button
                    onClick={() => window.open("./patientForm.pdf", "_blank")} title="Patient Clinic Form"
                    className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>

                    <span className="relative">
                      <span className="block group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        Physician Order Form
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                        <CloudDownloadIcon /> Download
                      </span>
                    </span>
                  </button>
                  <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] font-bold text-[#cfa751]">
                    Order your Test Now
                  </p>
                </div>
              </div>
            </li>
            <li data-aos="fade-up" data-aso-delay="400" className="grid lg:grid-cols-2 grid-cols-1 py-10 border-b-[1px] border-[#fafaf6] border-opacity-40" id="survey">
              <div className="">
                <p className="text-[#cfa751] lg:mb-0 mb-4 sm:text-4xl text-2xl font-light">
                  Clinician Feedback Form
                </p>
              </div>
              <div>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                  Your feedback is precious to us.
                </p>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                  It will help us to maintain the high-quality services and keep
                  on improving it.
                </p>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6]">
                  It will strengthen our bond with other healthcare experts.
                </p>
                <div className="flex flex-row gap-3 items-center pt-2">
                  {" "}
                  <a
                    target="_blank"
                    href="https://www.acr.org/Clinical-Resources/Clinical-Tools-and-Reference/Appropriateness-Criteria"
                    rel="noreferrer noopener"
                  >
                    <button className="group relative inline-flex h-14 w-full lg:w-[256px] mt-3 items-center rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>

                      <span className="relative">
                        <span className="block group-hover:opacity-0 px-3 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Start your survey
                        </span>
                        <span className="absolute flex flex-row gap-2 top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          <OpenInNewIcon /> Open
                        </span>
                      </span>
                    </button>
                  </a>
                </div>
              </div>
            </li>
            <li data-aos="fade-up" data-aso-delay="500" className="grid lg:grid-cols-2 grid-cols-1 py-10 border-b-[1px] border-[#fafaf6] border-opacity-40" id="resources">
              <div className="">
                <p className="text-[#cfa751] sm:text-4xl text-2xl lg:mb-0 mb-4 font-light">
                  Resources for Clinicians
                </p>
              </div>
              <div>
                <p className="font-Matter xl:text-2xl md:text-xl sm:text-lg text-[16px] text-[#fafaf6] pb-2">
                  Our updated resources will help clinicians to make informed
                  decisions for the patient’s condition by guiding them through
                  proper guidelines and advanced tests, as we continuously
                  invest in a research program to maintain the best care
                  possible.
                </p>

                <div className="flex flex-row gap-3 items-center pt-2">
                  {" "}
                  <a
                    target="_blank"
                    href="https://www.acr.org/Clinical-Resources/Clinical-Tools-and-Reference/Appropriateness-Criteria"
                    rel="noreferrer noopener"
                  >
                    <button className="group relative inline-flex h-14 mt-3 w-full lg:w-[256px] items-center rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>

                      <span className="relative">
                        <span className="block group-hover:opacity-0 px-3 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Get the Resources
                        </span>
                        <span className="absolute  top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          <OpenInNewIcon /> Open
                        </span>
                      </span>
                    </button>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ForClinics;
